const DB_NAME = "fluidsdata-eda";
const STORE = "payloads";
const VERSION = 1;

function openDb() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") {
      reject(new Error("IndexedDB unavailable"));
      return;
    }
    const request = indexedDB.open(DB_NAME, VERSION);
    request.onupgradeneeded = () => request.result.createObjectStore(STORE);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

async function withStore(mode, fn) {
  const db = await openDb();
  try {
    return await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE, mode);
      const request = fn(tx.objectStore(STORE));
      tx.oncomplete = () => resolve(request && request.result);
      tx.onerror = () => reject(tx.error);
      tx.onabort = () => reject(tx.error);
    });
  } finally {
    db.close();
  }
}

function userIdFromToken(token) {
  if (!token) return "anonymous";
  try {
    const part = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const claims = JSON.parse(atob(part + "=".repeat((4 - (part.length % 4)) % 4)));
    return claims.oid || claims.sub || claims.email || claims.unique_name || claims.preferred_username || token;
  } catch {
    return token;
  }
}

export function cacheKey(tenantId) {
  return `${tenantId}|${userIdFromToken(localStorage.getItem("authToken"))}`;
}

export async function readCachedPayload(key) {
  try {
    return (await withStore("readonly", (store) => store.get(key))) || null;
  } catch (error) {
    console.warn("EDA cache read failed:", error);
    return null;
  }
}

export async function writeCachedPayload(key, payload) {
  try {
    await withStore("readwrite", (store) => store.put({ ...payload, savedAt: Date.now() }, key));
  } catch (error) {
    console.warn("EDA cache write failed:", error);
  }
}

let reloadConsumed = false;
export function consumePageReload() {
  if (reloadConsumed) return false;
  reloadConsumed = true;
  try {
    const nav = performance.getEntriesByType("navigation")[0];
    return !!nav && nav.type === "reload" && String(nav.name).includes("/exploratory-data-analysis/");
  } catch {
    return false;
  }
}
